import React, { useContext, useEffect } from 'react';
import * as S from './styled';
import { LocaleContext } from '../Layout';


const Languages = () => { 

  const { locale } = useContext(LocaleContext);

  const pathDef = typeof window !== 'undefined' ? location.pathname : '/';
  const path = typeof window !== 'undefined' ? location.pathname.slice(3) : '/';
  
  return (
    <S.LanguageWrapper>

    
      <S.LanguageItem>
        
        <S.LanguageLink className={locale === 'en' ? 'current' : ''} to={locale === 'nl' ? `/en${pathDef}` : `/en${path}`} hrefLang="en">      
          en
        </S.LanguageLink>
      </S.LanguageItem>
      <S.LanguageItem>
        <S.LanguageLink className={locale === 'nl' ? 'current' : ''} to={locale === 'nl' ? `${pathDef}` : `${path}`} hrefLang="nl">
          nl
        </S.LanguageLink>
      </S.LanguageItem>
      <S.LanguageItem>
        <S.LanguageLink className={locale === 'de' ? 'current' : ''} to={locale === 'nl' ? `/de${pathDef}` : `/de${path}`} hrefLang="de">
          de
        </S.LanguageLink>
      </S.LanguageItem>
    </S.LanguageWrapper>
  );
};

export default Languages;

// {locale === 'en' ? 'current' : ''}